import type { IBatchStore } from './batch-store-types';
import { DeviceTypes } from '../../constants/DeviceModels';
import { timerKey } from '../../utils/timer-manager/timer-manager';
import logger from '../../utils/logger';

export const timerMixin = {

  clearBeltsTimers(this: IBatchStore): void {
    this.devicesStore.belts.forEach((belt: any) => {
      if (belt.onPNo && this.isBeltOn(belt.id)) {
        logger.log('clear belt timer', belt.description);
        this.timers.clear(timerKey.belt(belt.id));
      }
    });
  },

  clearAllTimers(this: IBatchStore): void {
    this.clearTimers();
    this.clearExtraTimers();
  },

  clearTimers(this: IBatchStore): void {
    // Clear batch-level timers (NOT system timers like version, pacInitial, observe, etc.)
    this.timers.clear(timerKey.startBatch());
    this.timers.clear(timerKey.goToDischarge());
    this.timers.clear(timerKey.checkDataInScaleQueue());
    this.timers.clear(timerKey.dischargeToNextScaleTimer());
    this.timers.clear(timerKey.discharge());
    this.timers.clear(timerKey.nextStep());
    this.timers.clear(timerKey.finishBatch());
    this.timers.clear(timerKey.override());
    this.timers.clear(timerKey.batchAction());
    this.timers.clear(timerKey.checkAdmixturesFinish());
    this.timers.clear(timerKey.demo());
    this.timers.clear(timerKey.beltsRunning());
    this.timers.clear(timerKey.dischargeWater());
    this.timers.clear(timerKey.rampUp());
    this.timers.clear(timerKey.dischargeAuthorization());

    // Clear device-specific timers
    this.devicesStore.devices.forEach((device: any) => {
      this.timers.clear(timerKey.device(device.id));
      this.timers.clear(timerKey.scaleWeight(device.id));
      this.timers.clear(timerKey.metered(device.id));
      this.timers.clear(timerKey.dischargeDelay(device.id));
      this.timers.clear(timerKey.dischargeFinish(device.id));
      this.timers.clear(timerKey.batchMetered(device.id));
      this.timers.clear(timerKey.setMeterSent(device.id));
      this.timers.clear(timerKey.initialAdjustDelay(device.id));
      this.timers.clear(timerKey.beltResume(device.id));
      this.timers.clear(timerKey.tankEmpty(device.id));
      this.timers.clear(timerKey.tankDischarge(device.id));
      this.timers.clear(timerKey.tankDischargeDelay(device.id));
      this.timers.clear(timerKey.jog(device.id));
      this.timers.clear(timerKey.jogUpdate(device.id));
      this.timers.clear(timerKey.mixerFinishDelay(device.id));
      this.timers.clear(timerKey.overrideDevice(device.id));

      if (device.deviceTypeName === DeviceTypes.Scale) {
        this.timers.clear(timerKey.custom('close-scale', device.id));
        this.timers.clear(timerKey.custom('close-scale', device.id, device.openGateOnePNo));
        this.timers.clear(timerKey.custom('close-scale', device.id, device.openGateTwoPNo));
        this.timers.clear(timerKey.custom('close-scale', device.id, device.openGateThreePNo));
        this.timers.clear(timerKey.dischargeToNextScale(device.id));
        this.timers.clear(timerKey.dischargeToNextScaleDelay(device.id));
        this.timers.clear(timerKey.secondGateOpen(device.id));
      }
    });

    // Clear material-specific timers
    this.materialStore.assignedMaterials.forEach((material: any) => {
      this.timers.clear(timerKey.batchMaterial(material.itemId));
      this.timers.clear(timerKey.checkFinalWeight(material.itemId));
    });
  },

  clearExtraTimers(this: IBatchStore): void {
    // Clear device control timers (horn, belt, screw)
    this.devicesStore.devices.forEach((device: any) => {
      this.timers.clear(timerKey.custom('horn', device.id));
      this.timers.clear(timerKey.belt(device.id));
      this.timers.clear(timerKey.custom('screw', device.id));
    });
  },

};
